var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-flex",
    { staticStyle: { padding: "0" }, attrs: { xs12: "" } },
    [
      _c(
        "Loading",
        {
          attrs: {
            visible: _vm.loading,
            message: "Caricamento...",
            templateType: _vm.loadTemplateCorrente,
          },
        },
        [
          _c(
            "v-data-table",
            {
              attrs: {
                items: _vm.items,
                "items-per-page": _vm.itemsPerPage,
                "hide-default-footer": "",
              },
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c("thead", { staticClass: "v-data-table-header" }, [
                        _c(
                          "tr",
                          _vm._l(_vm.headers, function (header, index) {
                            return _c(
                              "th",
                              {
                                key: "head_" + index,
                                staticClass: "text-center",
                              },
                              [
                                _c("span", [_vm._v(_vm._s(header.value))]),
                                header.filter
                                  ? _c("FilterPopup", {
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: {
                                        field: header.filter.field,
                                        initialValue:
                                          _vm.filters[header.filter.field],
                                        type: header.filter.type,
                                        dataSource: header.filter.dataSource,
                                      },
                                      on: {
                                        setFilter: _vm.onSetfilter,
                                        removeFilter: _vm.onRemoveFilter,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "item",
                  fn: function ({ item }) {
                    return [
                      _c(
                        "tr",
                        {
                          class: {
                            "row-zero-percent-progress": item.progresso == 0,
                            "row-hundred-percent-progress":
                              item.progresso >= 100,
                          },
                        },
                        [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                "text-align": "center",
                                width: "8%",
                              },
                            },
                            [
                              _c("ProgressBar", {
                                model: {
                                  value: item.progresso,
                                  callback: function ($$v) {
                                    _vm.$set(item, "progresso", $$v)
                                  },
                                  expression: "item.progresso",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "td",
                            {
                              staticStyle: {
                                "text-align": "center",
                                width: "23%",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    item.stagione
                                      ? item.stagione
                                      : "Nessuna stagione indicata"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "td",
                            {
                              staticStyle: {
                                "text-align": "center",
                                width: "23%",
                              },
                            },
                            [_vm._v(" " + _vm._s(item.capiLanciati) + " ")]
                          ),
                          _c(
                            "td",
                            {
                              staticStyle: {
                                "text-align": "center",
                                width: "23%",
                              },
                            },
                            [_vm._v(" " + _vm._s(item.capiRientrati) + " ")]
                          ),
                          _c(
                            "td",
                            {
                              staticStyle: {
                                "text-align": "center",
                                width: "23%",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    item.capiLanciati - item.capiRientrati
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            },
            [_c("template", { slot: "no-data" })],
            2
          ),
          _c("div", { staticClass: "pagination text-xs-center" }, [
            _c(
              "div",
              { staticClass: "pagination-buttons" },
              [
                _c("v-pagination", {
                  attrs: { length: _vm.pageCount, disabled: _vm.loading },
                  model: {
                    value: _vm.page,
                    callback: function ($$v) {
                      _vm.page = $$v
                    },
                    expression: "page",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }